var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfflineAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.003,
    height: 15.866,
    viewBox: "0 0 18.003 15.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29424",
    "data-name": "Rectangle 29424",
    width: 18.003,
    height: 15.866,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offline_alert_icon",
    "data-name": "Offline alert icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98790",
    "data-name": "Group 98790",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12153",
    "data-name": "Path 12153",
    d: "M2.515,15.867a2.531,2.531,0,0,1-2.174-3.8L6.834,1.227h0a2.529,2.529,0,0,1,4.331,0l6.487,10.83A2.554,2.554,0,0,1,18,13.31a2.533,2.533,0,0,1-2.508,2.557ZM8.549,2.254h0L2.064,13.081a.53.53,0,0,0,.2.715.542.542,0,0,0,.26.071H15.486a.518.518,0,0,0,.364-.159A.531.531,0,0,0,16,13.33a.544.544,0,0,0-.073-.262L9.452,2.254a.519.519,0,0,0-.324-.236.528.528,0,0,0-.4.061.538.538,0,0,0-.177.175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12154",
    "data-name": "Path 12154",
    d: "M9,9.739a1,1,0,0,1-1-1V5.675a1,1,0,1,1,2,0V8.739a1,1,0,0,1-1,1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12155",
    "data-name": "Path 12155",
    d: "M9.005,12.8a1,1,0,0,1-.71-.3,1.016,1.016,0,0,1-.22-.32,1.066,1.066,0,0,1,0-.76.955.955,0,0,1,.22-.33.981.981,0,0,1,1.41,0,.834.834,0,0,1,.22.33.942.942,0,0,1,0,.76.875.875,0,0,1-.22.32.994.994,0,0,1-.7.3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineAlertIcon);
export default __webpack_public_path__ + "static/media/offline_alert_icon.03ad4bd8.svg";
export { ForwardRef as ReactComponent };